var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMailIcon = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 21,
  height: 17,
  fill: "none",
  viewBox: "0 0 21 17",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#0F8491",
  d: "M20.25 0H.75A.75.75 0 0 0 0 .75v15c0 .415.335.75.75.75h19.5a.75.75 0 0 0 .75-.75v-15a.75.75 0 0 0-.75-.75m-.937 2.597v12.216H1.688V2.597l-.647-.504.92-1.184 1.004.78h15.073L19.04.91l.92 1.184zm-1.275-.91L10.5 7.548l-7.537-5.86-1.004-.78-.92 1.184.646.504L9.691 8.82a1.31 1.31 0 0 0 1.61 0l8.012-6.223.646-.504-.92-1.184z"
})));
export { SvgMailIcon as ReactComponent };
export default __webpack_public_path__ + "assets/images/mail_icon.svg";